import Table from "./TableBankRoller.jsx";

export default Table;
